import RedoButton from "./Redo";

export default {
    button: RedoButton,
    name: "redo",
};
